import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { Skills } from "@/types/skillsTypes"

export const useSkillsData = () => {
  //✅
  return useGenericQuery<Skills>({
    keys: QUERY_KEYS.skills.index(),
    apiEndpoint: ENDPOINTS.skills.index(),
  })
}
